import React from "react";
import {Button} from "react-bootstrap";
import {FaPlus} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import SummaryCards from "./SummaryCard";
import SalesGraph from "./SalesGraph";
import RecentOrders from "./RecentOrders";
import "../../assets/Css/Homedashboard.css";

const Dashboard = ({data, order}) => {
    const navigate = useNavigate();
    const dateLabel = new Intl.DateTimeFormat("en-IN", {weekday: "long", day: "numeric", month: "long"}).format(new Date());

    return (
        <div className="dashboard-content">
            <div className="dashboard-heading">
                <div>
                    <h2>Your store at a glance</h2>
                    <p>Track sales, orders and the work that needs your attention.</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <span className="dashboard-date">{dateLabel}</span>
                    <Button className="dashboard-add-button" onClick={() => navigate("/addProduct")}>
                        <FaPlus /> <span>Add product</span>
                    </Button>
                </div>
            </div>
            <SummaryCards data={data} />
            <SalesGraph data={data} />
            <RecentOrders data={order} />
        </div>
    );
};

export default Dashboard;
